import { propFactory as PropertiesFactory } from "./../../PropertiesFactory";
import { FormWidgetType, FormWidgetsListMap } from '@wm/core';
import { dbpropFactory as DBPropertiesFactory } from "./../../DBPropertiesFactory";
import { cloneDeep, forEach, get, set } from "lodash-es";

declare const window: any;
const formFieldPrefix = 'wm-form-field-';

const widgetProps: Map<string, any> = (() => {
  const props = new Map<string, {[key: string]: any}>();
  for (const key in FormWidgetType) {
    props.set(formFieldPrefix + get(FormWidgetType, key), {});
  }
  return props;
})();

// register the widgetProps with the given identifier
export const register = (identifier: string, props?: Map<string, any> | {[key: string]: any}, isObject?: boolean) => {
  if (!props) {
    props = PropertiesFactory.getWidgetProperties(identifier) || {};
  }
  if(identifier === 'wm-db-table' || identifier === 'wm-db-table-column' || identifier === 'wm-db' || identifier === 'wm-db-column-relation') 
    props = DBPropertiesFactory.getWidgetProperties(identifier) || {};
  if (props instanceof Map) {
    props = Object.fromEntries(props);
  }
  let widgetList = get(FormWidgetsListMap, identifier);
  if (widgetList) {
    widgetList.forEach((widget: FormWidgetType) => {
      props && registerFormWidget(widget, props);
    });
  }
  widgetProps.set(identifier, props);
  window.WM_LOADED_COMPONENTS = [...window.WM_LOADED_COMPONENTS || [], identifier ];
};

export const registerFormWidget = (identifier: string, props: Map<string, any> | {[key: string]: any}) => {
  const widgetName = formFieldPrefix + identifier;
  const existingProps = widgetProps.get(widgetName);
  if (existingProps) {
    forEach(props, (v: any, k: string) => set(existingProps, k, v));
  }
};

// returns the widgetPropsMap associated with the given identifier
// @ts-ignore
export const getWidgetPropsByType = (identifier: string): { [key: string]: any } => cloneDeep(widgetProps.get(identifier));

export const getWidgetPropsMap = () => widgetProps;

export enum PROP_TYPE {
  BOOLEAN = 1,
  NUMBER,
  STRING
}

export const PROP_STRING: any = {type: PROP_TYPE.STRING};
export const PROP_NUMBER: any = {type: PROP_TYPE.NUMBER};
export const PROP_BOOLEAN: any = {type: PROP_TYPE.BOOLEAN};
export const PROP_ANY: any = {arrayType: true};

